export const config = {
    appname: 'Mega Bangna App',
    client_id: '1880778358712212', // App ID
    facebook_app_id: '1880778358712212', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    agency_id: '',
    bzbsUrl: 'https://stg5.buzzebees.com',
    bzbsAddItemFromList: 'https://stg5.buzzebees.com/api/cart/',
    bzbsBlobUrl: 'https://stgstoragebuzzebees.blob.core.windows.net',
    bzbsShoppingCartUrl: 'https://stg-web-shoppingcart.azurewebsites.net/',
    bzbAddItem: 'https://stgc.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://stgc.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://stw.buzzebees.com',
    bzbsPointExpire: 'https://stw.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "",
        authDomain: "",
        databaseURL: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: ""
    },
};
